"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Name = "loyalty-dialog-result";
exports.LoyaltyDialogResultEvent = exports.Name;
var Result;
(function (Result) {
    Result["BUY_FOR_MONEY"] = "BUY_FOR_MONEY";
    Result["BUY_FOR_POINTS"] = "BUY_FOR_POINTS";
    Result["CLOSE"] = "CLOSE";
})(Result = exports.Result || (exports.Result = {}));
exports.isLoyaltyBuyForMoneyResult = function (result) { return result === Result.BUY_FOR_MONEY; };
exports.isLoyaltyBuyForPointsResult = function (result) { return result === Result.BUY_FOR_POINTS; };
exports.isLoyaltyCloseResult = function (result) { return result === Result.CLOSE; };
